import React from 'react'
import styled from 'styled-components'
import { useTranslations } from '../../utils/Text'
import media from '../../utils/media'

const ContainerFull = styled.div`
  position: relative;
  margin-bottom: ${props => props.marginB}px;
  ${media.mobileL`
    margin-bottom: calc(${props => props.marginB}px/3);
  `}
`

const ImageComponentFull = styled.div`
  background: url(${props => props.imgDesktop});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  height: ${props =>
    props.heightDesktop ? props.heightDesktop : '424px'};
  width: 100%;
  ${media.tabletS`
    background-image: url(${props => props.imgMobile});
    height: ${props =>
      props.heightMobile ? props.heightMobile : '537px'};
  `}
`

export default function CustomBanner({ config }) {
  const {
    imgDesktop,
    imgMobile,
    heightDesktop,
    heightMobile,
    maxHeight,
    marginB,
    optional,
  } = config

  const imgDesktopToShow = useTranslations(imgDesktop, { optional })
  const imgMobileToShow = useTranslations(imgMobile, { optional })
  if (
    optional &&
    imgDesktopToShow === null &&
    imgMobileToShow === null
  )
    return null

  return (
    <>
      <ContainerFull className="container-wrapper" marginB={marginB}>
        <ImageComponentFull
          className="here"
          imgDesktop={imgDesktopToShow}
          imgMobile={imgMobileToShow}
          maxHeight={maxHeight}
          heightDesktop={heightDesktop}
          heightMobile={heightMobile}
        >
          &nbsp;
        </ImageComponentFull>
      </ContainerFull>
    </>
  )
}
